export const responsesFilter = {
    inputs: [
        {
            name: 'name',
            label: 'Nome',
            col: '3',
            type: 'text'
        },
        {
            name: 'email',
            label: 'Email',
            col: '3',
            type: 'text'
        },
        {
            name: 'date_start',
            label: 'Data Início',
            col: '3',
            type: 'date'
        },
        {
            name: 'date_end',
            label: 'Data Fim',
            col: '3',
            type: 'date'
        },
    ],
    selects: [
        {
            name: 'form_id',
            label: 'Formulário',
            col: '3',
            options: [
                { value: '', text: 'Todos os formulários' }
            ]
        },
        {
            name: 'status',
            label: 'Status',
            col: '3',
            options: [
                { value: '', text: 'Todos os status' },
                { value: 'pending', text: 'Pendente' },
                { value: 'approved', text: 'Aprovado' },
                { value: 'rejected', text: 'Rejeitado' },
            ]
        }
    ]
};
